import type { Ruleset } from './types.js';

export interface RulesetValidationIssue {
  field: string;
  message: string;
}

export interface RulesetValidationResult {
  valid: boolean;
  issues: RulesetValidationIssue[];
}

const SPECIAL_CONTRACT_LAYERS = ['nello', 'plunge', 'splash', 'sevens'] as const;

export function validateRuleset(ruleset: Ruleset): RulesetValidationResult {
  const issues: RulesetValidationIssue[] = [];

  if (!ruleset.name.trim()) {
    issues.push({ field: 'name', message: 'Ruleset name is required.' });
  }

  const hasTournament = ruleset.enabledLayers.includes('tournament');
  const enabledSpecials = SPECIAL_CONTRACT_LAYERS.filter((layer) =>
    ruleset.enabledLayers.includes(layer),
  );

  if (hasTournament && enabledSpecials.length > 0) {
    issues.push({
      field: 'enabledLayers',
      message: `Tournament restrictions disable special contracts. Turn off ${enabledSpecials.join(', ')} or disable tournament mode.`,
    });
  }

  if (ruleset.openingBidCapMarks !== null) {
    if (ruleset.openingBidCapMarks < 1 || ruleset.openingBidCapMarks > 4) {
      issues.push({
        field: 'openingBidCapMarks',
        message: 'Opening bid cap must be between 1 and 4 marks, or left unset.',
      });
    }
  }

  if (!ruleset.allowDoublesTrump && ruleset.enabledLayers.includes('plunge')) {
    issues.push({
      field: 'allowDoublesTrump',
      message: 'Plunge requires doubles in hand. Keep doubles trump enabled or disable Plunge.',
    });
  }

  return {
    valid: issues.length === 0,
    issues,
  };
}

export function rulesetRequiresHouseRulesLayer(ruleset: Ruleset): boolean {
  return (
    ruleset.openingBidCapMarks !== null ||
    !ruleset.allowFollowMe ||
    !ruleset.allowDoublesTrump
  );
}
